<template>
  <div class="check-in-page">
    <div class="header">
      <div class="title">今日打卡</div>
      <div class="sub" v-if="status.merchantName">{{ status.merchantName }}</div>
    </div>

    <div class="card status-card">
      <div class="status-icon" :class="{ done: status.checkedInToday, warn: !status.enabled }">
        <van-icon :name="statusIcon" size="48" />
      </div>
      <div class="status-text">{{ statusMessage }}</div>
      <div class="project-name" v-if="projectName">任务：{{ projectName }}</div>
    </div>

    <div v-if="status.needProfile" class="tip-box">
      <van-button block round type="primary" @click="goUserInfo">先去完善个人信息</van-button>
    </div>

    <div v-else-if="status.enabled && !status.checkedInToday && todayProject" class="action-area">
      <div v-if="photoPreview" class="photo-preview">
        <img :src="photoPreview" alt="拍照预览" />
      </div>
      <input
        ref="cameraInput"
        type="file"
        accept="image/*"
        capture="environment"
        class="hidden-input"
        @change="onPhotoSelected"
      />
      <van-button
        block
        round
        size="large"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        :loading="loading"
        loading-text="提交中..."
        class="main-btn"
        @click="handleCheckIn"
      >
        {{ buttonText }}
      </van-button>
      <div class="hint" v-if="status.needPhoto">请对准本人面部拍照后打卡</div>
    </div>

    <footer-menu></footer-menu>
  </div>
</template>

<script>
import requestHTAPI from '@/axios/HantangTax'
import footerMenu from '@/components/footer/FooterMenu'

export default {
  name: 'CheckIn',
  components: { footerMenu },
  data () {
    return {
      status: {},
      loading: false,
      photoFile: null,
      photoPreview: '',
      uploadedPhoto: null
    }
  },
  computed: {
    projectName () {
      const p = this.status.todayProject
      return p && p.name ? p.name : ''
    },
    todayProject () {
      return this.status.todayProject
    },
    statusMessage () {
      if (!this.status.enabled) return '当前企业未开通打卡'
      if (this.status.needProfile) return '请先完善个人信息'
      if (!this.todayProject) return '今日暂无任务，请稍后再来'
      if (this.status.checkedInToday) return '今日已打卡，辛苦了！'
      if (this.status.needPhoto) return '本周首次打卡，需要拍照'
      return '点击下方按钮完成打卡'
    },
    buttonText () {
      if (this.status.needPhoto) {
        return this.photoPreview ? '确认拍照打卡' : '拍照并打卡'
      }
      return '立即打卡'
    },
    statusIcon () {
      if (!this.status.enabled) return 'warning-o'
      if (this.status.checkedInToday) return 'checked'
      return 'clock-o'
    }
  },
  mounted () {
    this.loadStatus()
  },
  methods: {
    getMerNo () {
      return localStorage.getItem('MERNO') || ''
    },
    loadStatus () {
      requestHTAPI.checkInStatus({ merNo: this.getMerNo() }).then(res => {
        if (res.data.code === '0000') {
          this.status = res.data.data || {}
        } else {
          this.$toast.fail(res.data.message || '加载失败')
        }
      })
    },
    goUserInfo () {
      this.$router.push({ name: 'userInfo' })
    },
    handleCheckIn () {
      if (this.loading) return
      if (this.status.needPhoto && !this.photoPreview) {
        this.$refs.cameraInput.click()
        return
      }
      this.submitCheckIn()
    },
    onPhotoSelected (e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      this.photoFile = file
      this.photoPreview = URL.createObjectURL(file)
      e.target.value = ''
    },
    submitCheckIn () {
      this.loading = true
      const doCheckIn = (fileData) => {
        const payload = {
          merNo: this.getMerNo(),
          projectId: this.status.projectId,
          merchantId: this.status.merchantId
        }
        if (fileData) {
          payload.file = fileData
        }
        return requestHTAPI.checkIn(payload)
      }
      const chain = this.status.needPhoto && this.photoFile
        ? this.uploadPhoto().then(fileData => doCheckIn(fileData))
        : doCheckIn()
      chain.then(res => {
        if (res.data.code === '0000') {
          this.$toast.success(res.data.message || '打卡成功')
          this.photoPreview = ''
          this.photoFile = null
          this.loadStatus()
        } else {
          this.$toast.fail(res.data.message || '打卡失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    uploadPhoto () {
      const formData = new FormData()
      formData.append('file', this.photoFile)
      return requestHTAPI.picZip(formData).then(res => {
        if (res.data.code === '0000') {
          return res.data.data
        }
        throw new Error(res.data.message || '照片上传失败')
      })
    }
  }
}
</script>

<style scoped>
.check-in-page {
  min-height: 100vh;
  background: #f6f8fc;
  padding: 20px 16px 80px;
}
.header {
  text-align: center;
  padding: 24px 0 16px;
}
.title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}
.sub {
  margin-top: 8px;
  font-size: 16px;
  color: #666;
}
.status-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 20px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  margin-bottom: 24px;
}
.status-icon {
  color: #ee0a24;
  margin-bottom: 16px;
}
.status-icon.done { color: #07c160; }
.status-icon.warn { color: #ff976a; }
.status-text {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
}
.project-name {
  margin-top: 12px;
  font-size: 15px;
  color: #888;
}
.action-area {
  padding: 0 8px;
}
.main-btn {
  height: 52px;
  font-size: 20px;
  font-weight: 600;
}
.hint {
  text-align: center;
  margin-top: 16px;
  color: #999;
  font-size: 14px;
}
.hidden-input {
  display: none;
}
.photo-preview {
  margin-bottom: 16px;
  text-align: center;
}
.photo-preview img {
  max-width: 100%;
  max-height: 240px;
  border-radius: 12px;
}
.tip-box {
  padding: 0 8px;
}
</style>
